import { FC } from 'react';
import { useAccessibilityContext, } from 'shared/contexts/accessibility-context';
import type { A11yTheme } from 'shared/hooks/use-accessibility';

const THEMES: { key: A11yTheme; label: string; cls: string }[] = [
    { key: 'white', label: 'Чёрным по белому', cls: 'a11y-sw-white' },
    { key: 'black', label: 'Белым по чёрному', cls: 'a11y-sw-black' },
    { key: 'blue', label: 'Тёмно-синим по голубому', cls: 'a11y-sw-blue' },
];

// Панель настроек версии для слабовидящих (ГОСТ Р 52872).
// Стили — в глобальном слое src/shared/styles/accessibility.css.
export const AccessibilityPanel: FC = () => {
    const {
        enabled,
        theme,
        images,
        letterSpacing,
        setTheme,
        setImages,
        setLetterSpacing,
        incFont,
        decFont,
        disable,
    } = useAccessibilityContext();

    if (!enabled) return null;

    return (
        <div className="a11y-panel" role="region" aria-label="Настройки версии для слабовидящих">
            <div className="a11y-group">
                <span className="a11y-label">Размер шрифта</span>
                <button type="button" onClick={decFont} aria-label="Уменьшить шрифт">А-</button>
                <button type="button" onClick={incFont} aria-label="Увеличить шрифт">А+</button>
            </div>

            <div className="a11y-group">
                <span className="a11y-label">Цвет сайта</span>
                {THEMES.map((t) => (
                    <button
                        key={t.key}
                        type="button"
                        className={`a11y-swatch ${t.cls} ${theme === t.key ? 'is-active' : ''}`}
                        onClick={() => setTheme(t.key)}
                        aria-pressed={theme === t.key}
                        aria-label={t.label}
                    >
                        Ц
                    </button>
                ))}
            </div>

            <div className="a11y-group">
                <span className="a11y-label">Изображения</span>
                <button
                    type="button"
                    className={images === 'on' ? 'is-active' : ''}
                    onClick={() => setImages('on')}
                    aria-pressed={images === 'on'}
                >
                    Вкл
                </button>
                <button
                    type="button"
                    className={images === 'off' ? 'is-active' : ''}
                    onClick={() => setImages('off')}
                    aria-pressed={images === 'off'}
                >
                    Выкл
                </button>
            </div>

            <div className="a11y-group">
                <span className="a11y-label">Интервал</span>
                <button
                    type="button"
                    className={letterSpacing === 'normal' ? 'is-active' : ''}
                    onClick={() => setLetterSpacing('normal')}
                    aria-pressed={letterSpacing === 'normal'}
                >
                    Обычный
                </button>
                <button
                    type="button"
                    className={letterSpacing === 'large' ? 'is-active' : ''}
                    onClick={() => setLetterSpacing('large')}
                    aria-pressed={letterSpacing === 'large'}
                >
                    Большой
                </button>
            </div>

            <button type="button" className="a11y-normal" onClick={disable}>
                Обычная версия сайта
            </button>
        </div>
    );
};
